export default __webpack_public_path__ + "static/media/walk.db4e92dc.svg";